// src/components/fields.js
import API_BASE_URL from '../../../../Constants';

export const steps = ['Invoice Details', 'Address Information', 'Financial Information'];

export const stepFields = [
  // Step 1: Invoice Details
  [
    { name: 'invoiceNumber', label: 'Invoice Number', type: 'text' },
    { name: 'invoiceDate', label: 'Invoice Date', type: 'date' },
    { name: 'customer', label: 'Customer', type: 'text' },
    { 
      name: 'buildingID', 
      label: 'Building ID', 
      type: 'select', 
      fetchUrl: API_BASE_URL + '/api/setup/buildings/all', 
      optionLabel: 'buildingID', 
      optionValue: 'buildingID' 
    }
  ],
  // Step 2: Address Information
  [
    { name: 'addressOne', label: 'Address One', type: 'text' },
    { name: 'addressTwo', label: 'Address Two', type: 'text' },
    { name: 'city', label: 'City', type: 'text' },
    { name: 'state', label: 'State', type: 'text' },
    { name: 'zip', label: 'ZIP Code', type: 'text' }
  ],
  // Step 3: Financial Information
  [
    { name: 'invoiceAmount', label: 'Invoice Amount', type: 'number' },
    { name: 'partsAmount', label: 'Parts Amount', type: 'number' },
    { name: 'discountAmount', label: 'Discount Amount', type: 'number' },
    { name: 'taxAmount', label: 'Tax Amount', type: 'number' },
    {
      name: 'isOpen',
      label: 'Open?',
      type: 'select',
      options: [
        { label: 'Yes', value: 'true' },
        { label: 'No', value: 'false' }
      ],
      optionLabel: 'label',
      optionValue: 'value'
    }
  ]
];
